import type {
  MultidietSetupSetupType,
  MultidietSetupVariantType,
} from "@/features/multidiet-picker/types/multidiet-setup.type";
import { create } from "zustand";

type Store = {
  multidietSetup: MultidietSetupSetupType | null;
  multidietSetupLabels: MultidietSetupVariantType[] | null;
  multidietSelectedLabel: MultidietSetupVariantType | null;
  isFetching: boolean;
  firstDeliveryDate: Date | null;
};

type Actions = {
  setMultidietSetup: (multidietSetup: MultidietSetupSetupType | null) => void;
  setMultidietSetupLabels: (
    multidietSetupLabels: MultidietSetupVariantType[] | null
  ) => void;
  setMultidietSelectedLabel: (
    multidietSelectedLabel: MultidietSetupVariantType | null
  ) => void;
  setIsFetching: (isFetching: boolean) => void;
  setFirstDeliveryDate: (firstDeliveryDate: Date | null) => void;
};

const initialState: Store = {
  multidietSetup: null,
  multidietSetupLabels: null,
  multidietSelectedLabel: null,
  isFetching: false,
  firstDeliveryDate: null,
};

const useMultidietSetupStore = create<Store & Actions>()((set) => ({
  ...initialState,
  setMultidietSetup: (multidietSetup) => set({ multidietSetup }),
  setMultidietSetupLabels: (multidietSetupLabels) =>
    set({ multidietSetupLabels }),
  setMultidietSelectedLabel: (multidietSelectedLabel) =>
    set({ multidietSelectedLabel }),
  setIsFetching: (isFetching) => set({ isFetching }),
  setFirstDeliveryDate: (firstDeliveryDate) => set({ firstDeliveryDate }),
}));

export default useMultidietSetupStore;
